// extracted by mini-css-extract-plugin
export var stepActive = "_2y-3";
export var stepCompleted = "_2y-4";
export var stepConnectorLine = "_2y-b";
export var stepIndicatorCircle = "_2y-6";
export var stepIndicatorCircleCompleted = "_2y-7";
export var stepIndicatorCircleDefault = "_2y-8";
export var stepIndicatorTextCompleted = "_2y-9";
export var stepIndicatorTextDefault = "_2y-a";
export var stepPending = "_2y-5";
export var wizardContainer = "_2y-1";
export var wizardContent = "_2y-2";
export var wizardModal = "_2y-0";